import { HOURS_FORMAT } from '@/components/base-components/components/time-picker/index.js';

export function getHours(format = HOURS_FORMAT.HOURS_24) {
    return Array.from({ length: format === HOURS_FORMAT.HOURS_24 ? 24 : 12 }, (_, value) => {
        const hour = format === HOURS_FORMAT.HOURS_24 ? value : (value % 12 || 12);

        return {
            value,
            label: hour.toString().padStart(2, '0'),
        };
    });
}

export function getMinutes(step = 1) {
    const steps = Math.floor(60 / step);

    return Array.from({ length: steps }, (_, i) => {
        const minute = i * step;

        return {
            value: minute,
            label: minute.toString().padStart(2, '0'),
        };
    });
}

export function getSeconds() {
    return [...Array(60).keys()].map(value => ({
        value,
        label: value.toString().padStart(2, '0'),
    }));
}
